import React, {Component} from 'react'
import {FormattedMessage, injectIntl} from 'react-intl'
import {Helmet} from 'react-helmet'
import {Link} from 'react-router-dom'

import hero1x from './rebecca-eric-recession@1x.jpg'
import hero2x from './rebecca-eric-recession@2x.jpg'

class Home extends Component {
  render () {
    return (
      <article>
        <Helmet>
          <title>{this.props.intl.formatMessage({id:'rebeccaAndEricsWedding'})}</title>
        </Helmet>

        <hgroup>
          <h1>Rebecca & Eric</h1>
          <h2>
            <FormattedMessage id="gotMarriedSubhed" />
          </h2>
        </hgroup>

        <section className="hero">
          <img
            srcSet={`${hero1x} 1x, ${hero2x} 2x`}
            src={hero1x}
            alt={this.props.intl.formatMessage({id:'heroAlt'})} />
        </section>

        <section>
          <h2><FormattedMessage id="dateAndPlace" /></h2>

          <p>
            <FormattedMessage id="dateAndPlaceCopy" values={{
              weddingDate: <b><FormattedMessage id="weddingDate" /></b>,
              theStillwellHouseLink:
                <a href="http://www.stillwellhouse.com">
                  <FormattedMessage id="theStillwellHouse" />
                </a>,
              tucsonAZLink:
                <a href="https://www.visittucson.org/">
                  Tucson, Arizona
                </a>,
            }} />
          </p>
        </section>

        <section>
          <h2><FormattedMessage id="ourPhotos" /></h2>

          <p>
            <FormattedMessage id="ourPhotosCopy" values={{
              weddingAlbumLink:
                <Link to="albums/wedding/">
                  <FormattedMessage id="weddingPhotos" />
                </Link>,
              honeymoonAlbumLink:
                <Link to="albums/honeymoon/">
                  <FormattedMessage id="honeymoonPhotos" />
                </Link>
            }} />
          </p>
        </section>

      </article>
    )
  }
}

export default injectIntl(Home)



// WEBPACK FOOTER //
// ./src/Home.js